(ns teamoesterreich.admin-mode.data.eventQuestion
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))





(defn <get-question-list [task-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-question/task/" task-uuid)
              (fn [r-list status]
                (log/debug "eventQuestion-list-elements done" r-list status)
                (when (= status 200)
                  (done-fn (into {} (map (fn [e] [(get e "crowdtaskerQuestion-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                           )))))



(defn >task-add-new-question  [task-uuid name index cb-fn]
  (ajax/auth-post> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-question" )
              (ajax/serialize {:crowdtaskerTask-uuid task-uuid
                               :crowdtaskerQuestion-active true
                               :crowdtaskerQuestion-index index
                               :crowdtaskerQuestion-question name})
              (fn [r-elem status]
                (log/debug "eventQuestion done" r-elem status)
                (when (= status 200)
                  (cb-fn (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elem))))
                         ))))
  )


(defn >question-save [uuid question cb-fn]
  (log/out uuid (ajax/serialize question))
  (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-question/" uuid)
             (ajax/serialize question)
             (fn [r-elem status]
               (log/debug "eventQuestion done" r-elem status)
               (when (= status 200)
                 (cb-fn (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elem))))
                        ))))
  )

(defn >question-save-index [uuid index cb-fn]
  (log/out uuid (ajax/serialize {:crowdtaskerQuestion-uuid uuid
                                 :crowdtaskerQuestion-index index}))
  (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-question/" uuid)
             (ajax/serialize {:crowdtaskerQuestion-uuid uuid
                              :crowdtaskerQuestion-index index})
             (fn [r-elem status]
               (log/debug "eventQuestion done" r-elem status)
               (when (= status 200)
                 (cb-fn (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elem))))
                        ))))
  )



(defn >answerOption-add-new  [question-uuid name index finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-answer-option" )
              (ajax/serialize {:crowdtaskerQuestion-uuid question-uuid
                               :crowdtaskerAnswerOption-active true
                               :crowdtaskerAnswerOption-index index
                               :crowdtaskerAnswerOption-type "checkbox"
                               :crowdtaskerAnswerOption-text name})
              finished-fn))

(defn >answerOption-save [uuid data finished-fn]
  (let [data (merge data [:crowdtaskerAnswerOption-uuid uuid])]
    (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/crowdtasker-answer-option/" uuid)
               (ajax/serialize data)
               finished-fn)))


(defn >answerOption-save-index [uuid index finished-fn]
  (>answerOption-save uuid {:crowdtaskerAnswerOption-index index} finished-fn))



(defn load-task-question-list [& [finished-fn]]
  (let [event-task (get-in @vstate/app-state [:selected-task])]
    (<get-question-list (:crowdtaskerTask-uuid event-task)
                        (fn [response]
                          (swap! vstate/app-state assoc-in [:edit-crowdtaskerQuestion :questions] response)
                          (when finished-fn (finished-fn))))))





